const bodyNode = document.body;
const OBSERVER_CONFIG = { attributes: true };
const DEFAULT_THEME = 'dark';
let observer;

const currentThemeMixin = {
  data() {
    return {
      currentTheme: DEFAULT_THEME,
    };
  },
  mounted() {
    try {
      // eslint-disable-next-line compat/compat
      observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.setTheme(mutation.target.classList);
          }
        });
      });
    } catch (err) {
      console.info('not supported MutationObserver, please install polyfill');
    }
    this.getTheme();
    this.subscribeOnThemeChange();
  },
  beforeDestroy() {
    if (observer) {
      this.unsubscribe();
    }
  },
  destroy() {
    observer = null;
  },
  methods: {
    setTheme(classList) {
      const classes = [].slice.call(classList);
      const regexFn = value => /^theme-/.test(value);
      const themeClass = classes.find(regexFn);
      const theme = themeClass ? themeClass.substring(6) : DEFAULT_THEME;
      if (theme !== this.currentTheme) {
        this.currentTheme = theme;
      }
    },
    getTheme() {
      this.setTheme(bodyNode.classList);
    },
    subscribeOnThemeChange() {
      if (observer) {
        observer.observe(bodyNode, OBSERVER_CONFIG);
      }
    },
    unsubscribe() {
      if (observer) {
        observer.disconnect();
      }
    },
  },
};

export default currentThemeMixin;
